import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import { Link } from 'react-router-dom';
import { FaRobot, FaKey, FaSignOutAlt, FaBars, FaEye } from 'react-icons/fa';
import logo from './assets/logo.png';
import { supabase } from './supabaseClient';

const Dashboard = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [userStats, setUserStats] = useState({
    totalEAs: 0,
    totalLicenses: 0,
    usedLicenses: 0,
    activeEAs: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      if (sessionError || !session?.user) return;

      const { data: allItems, error } = await supabase
        .from('robot_licenses')
        .select('*')
        .eq('user_id', session.user.id);

      if (error) {
        console.error('Fetch error:', error);
        return;
      }

      const bots = allItems.filter((item) => item.key === null); // Bots
      const licenses = allItems.filter((item) => item.key !== null); // License keys
      const usedLicenses = licenses.filter((item) => item.used === true);

      setUserStats({
        totalEAs: bots.length,
        totalLicenses: licenses.length,
        usedLicenses: usedLicenses.length,
        activeEAs: usedLicenses.length,
      });
    };

    fetchStats();
  }, []);

  const handleMenuClick = () => {
    setMenuOpen(true);
    setTimeout(() => setMenuOpen(false), 7000);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/login';
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="logo">
          <img src={logo} alt="logo" className="logo-img" />
          <span>Smart Trading Pro</span>
        </div>
        <button className="hamburger" onClick={handleMenuClick}><FaBars /></button>
      </div>

      {menuOpen && (
        <div className="menu-slide">
          <Link to="/manage-eas" className="menu-item"><FaRobot /> Manage EAs</Link>
          <Link to="/generate-keys" className="menu-item"><FaKey /> Generate Keys</Link>
          <Link to="/display-keys" className="menu-item"><FaEye /> Display Keys</Link>
          <button className="menu-item logout" onClick={handleLogout}><FaSignOutAlt /> Logout</button>
        </div>
      )}

      <div className="dashboard-cards">
        <div className="card card-ea"><h3>Total EAs</h3><p>{userStats.totalEAs}</p></div>
        <div className="card card-license"><h3>Total Licenses</h3><p>{userStats.totalLicenses}</p></div>
        <div className="card card-used"><h3>Used Licenses</h3><p>{userStats.usedLicenses}</p></div>
        <div className="card card-active"><h3>Active EAs</h3><p>{userStats.activeEAs}</p></div>
      </div>
    </div>
  );
};

export default Dashboard;